import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=4bc4ad57&scoped=true&"
var script = {}
import style0 from "./Block.vue?vue&type=style&index=0&id=4bc4ad57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc4ad57",
  null
  
)

export default component.exports